import React from 'react';
import * as Store from '@apply/store';
import { ShowIf, RentalPropertyReview, NonRentalPropertyReview, SubSectionHeader, DemographicsReview } from '@apply/ui';
import { LoanType } from '@apply/constants';

export interface PropertiesReviewProps {
    properties: Store.PropertiesStore.Types.PropertiesState;
    loanType: LoanType;
    apiId?: string;
    printMode?: boolean;
    formCompleted: boolean;
    token: string;
    collapsable: boolean;
}

export const PropertiesReview: React.FC<PropertiesReviewProps> = ({
    properties,
    loanType,
    apiId,
    printMode = false,
    formCompleted,
    token,
    collapsable,
}) => {
    return (
        <>
            <SubSectionHeader
                title='Property'
                printMode={printMode}
                formCompleted={formCompleted}
            />
            {properties?.items?.map((property, index) => (
                <React.Fragment key={index}>
                    <ShowIf showIf={[LoanType.BuildRent, LoanType.Rental].includes(loanType)}>
                        <RentalPropertyReview
                            key={property.guid}
                            loanType={loanType}
                            property={property}
                            index={index}
                            apiId={apiId}
                            formCompleted={formCompleted}
                            token={token}
                            printMode={printMode}
                            collapsable={collapsable}
                        />
                    </ShowIf>

                    <ShowIf showIf={![LoanType.BuildRent, LoanType.Rental].includes(loanType)}>
                        <NonRentalPropertyReview
                            key={property.guid}
                            property={property}
                            loanType={loanType}
                            index={index}
                            apiId={apiId}
                            printMode={printMode}
                            formCompleted={formCompleted}
                            token={token}
                            collapsable={collapsable}
                        />
                    </ShowIf>
                    {printMode && <DemographicsReview address={property.address} />}
                </React.Fragment>
            ))}
        </>
    );
};
